import { gql } from "graphql-tag";
import {
  BulkAction,
  ModalService,
  DataService,
  NotificationService,
} from "@bb-vendure/admin-ui/core";
import {
  RemoveFanClubMemberMutation,
  RemoveFanClubMemberDocument,
} from "src/generated-gql/graphql";
import { forkJoin, Observable } from "rxjs";

export const bulkRemoveFanClubMember: BulkAction = {
  location: "fan-club-member-table",
  label: "Remove Selected",
  icon: "warning",
  iconClass: "is-warning",
  onClick: ({ selection, injector, hostComponent, clearSelection }) => {
    const modalService = injector.get(ModalService);
    const dataService = injector.get(DataService);
    const notificationService = injector.get(NotificationService);
    modalService
      .dialog({
        title: `Remove ${selection.length}  fan club member ?`,
        buttons: [
          { type: "secondary", label: "Cancel" },
          { type: "primary", label: "Remove", returnValue: selection },
        ],
      })
      .subscribe((response) => {
        if (response) {
          const deleteObservables: Observable<RemoveFanClubMemberMutation>[] =
            [];
          for (const item in response) {
            deleteObservables.push(
              dataService.mutate(RemoveFanClubMemberDocument, {
                id: response[item].id,
              })
            );
          }
          forkJoin(deleteObservables).subscribe(() => {
            notificationService.success("Remove successfully");
            hostComponent.refresh();
            clearSelection();
          });
        }
      });
  },
};
